<template>
  <div class="text-xs-center">
    <!-- Dialog para criar ou editar um chat -->
    <v-dialog persistent v-model="dialog" scrollable max-width="700">
      <v-card>
        <v-card-title v-if="view === 3">
          <span class="headline">Editar Grupo</span>
          <v-tooltip v-if="editedItem.users.length > 1 || view === 3" right>
            <template slot="activator">
              <v-btn flat icon color="red" @click="deleteGroup()">
                <v-icon>delete</v-icon>
              </v-btn>
            </template>
            <span>Excluir Grupo</span>
          </v-tooltip>          
        </v-card-title>
        <v-card-title v-else>
          <span class="headline">{{editedItem.users.length > 1 ? 'Criar Grupo' : 'Criar Chat'}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text justify-center>
          <!-- :disabled="isUpdating" -->
          <v-form ref="form" @keyup.native.esc="cancel(400)" @keyup.native.ctrl.enter="beforeSave()">
            <v-container grid-list-md>
              <v-layout wrap justify-center align-center>
                <v-flex xs2 v-if="editedItem.users.length > 1 || view === 3">
                  <p-upload-cropped-image v-model="editedItem.img_path" @changeImage="changeImage">
                    <div slot="activator">
                      <v-avatar size="70px" v-ripple v-if="!editedItem.img_path" class="grey lighten-3">
                        <span>Foto</span>
                      </v-avatar>
                      <v-avatar size="70px" v-ripple v-else>
                        <img :src="blobImage?editedItem.img_path:`${basePath}uploads/chats/${editedItem.img_path}`" alt="avatar">
                      </v-avatar>
                    </div>
                  </p-upload-cropped-image>
                </v-flex>
                <v-flex xs10 v-if="editedItem.users.length > 1 || view === 3">
                  <v-text-field v-model="editedItem.id_text" label="Nome do Grupo"  maxlength="30" counter="30" :rules="requiredRule('nome',30)"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <p-select-user ref="userIllis" v-model="editedItem.users" :companyId="companyId" :multiple="true" :rules="requiredManyRule('participante')"></p-select-user>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" color="primary darken-2" @click.native="beforeSave">{{view === 3 ? 'Editar' : 'Criar'}}</v-btn>
          <v-btn class="mx-0" @click.native="cancel">Cancelar</v-btn>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIM Dialog para criar ou editar um chat -->

  </div>

</template>

<script>
  /* eslint-disable handle-callback-err */
  import PUploadCroppedImage from './PUploadCroppedImage'
  import PSelectUser from './PSelectUser'
  import general from '../../mixin/general'
  import rules from './../../mixin/rules'

  export default {
    components: {PUploadCroppedImage, PSelectUser},
    name: 'PChatCreate',
    mixins: [general, rules],
    props: {
      company_id: {
        type: Number
      }
    },
    data () {
      return {
        basePath: process.env.API,
        defaultItem: {users: [], img_path: '', id_text: '', company_id: ''},
        editedItem: {users: [], img_path: '', id_text: '', company_id: ''},
        // users: [],
        // companyId Usado para passar o valor da company para o PSelectUser e fazer os tratamentos de acordo com a empresa passada
        companyId: '',
        image: '',
        // 2 - create, 3 - edit
        view: 2,
        blobImage: false,
        dialog: false
      }
    },
    // mounted () {
    // },
    methods: {
      changeImage (val) {
        this.image = val
        this.blobImage = true
      },
      cancel () {
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
        this.dialog = false
        this.$emit('cancel')
      },
      openDialog (view, companyId, roomId) {
        this.view = view
        // Altera o companyId do componente de usuário para que faça as buscas de acordo com a empresa selecioanda no chat
        this.$refs.userIllis.companyId = companyId
        // Coloca o firstCLick false para não fazer dusa requisições na primeira vez que abre
        this.$refs.userIllis.firstClick = false
        // Busca a lista de registros
        this.$refs.userIllis.getUsersIllis()
        // this.$store.commit('loader/change_dialog', true)
        // this.$http.get(`api/get_users_illis_company/${companyId}`).then((res) => {
        //   // Filtra os usuários tirando o dono do chat
        //   this.users = res.body.filter((val) => { return !(val.id === `${this.$auth.user().id}-${companyId}`) })
        //   this.$store.commit('loader/change_dialog', false)
        //   if (view === 2) {
        //     this.dialog = true
        //     this.$emit('loading', false)
        //     this.editedItem = {users: [], img_path: '', id_text: '', company_id: companyId}
        //   }
        // })
        this.$store.commit('loader/change_dialog', false)
        if (view === 2) {
          this.dialog = true
          this.$emit('loading', false)
          this.editedItem = {users: [], img_path: '', id_text: '', company_id: companyId}
        } else if (view === 3) {
          this.$http.get('api/get_chat_room/' + roomId).then(
            (res) => {
              this.editedItem = res.body
              this.editedItem.company_id = companyId
              this.dialog = true
              this.$emit('loading', false)
            },
            err => {
              this.$emit('loading', false)
              this.$store.commit('snackbar/change_values', {
                text: 'Não foi possível criar o chat, reporte o erro.', color: 'error', dialog: true
              })
            })
        }
      },
      beforeSave () {
        if (this.$refs.form && !this.$refs.form.validate()) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning'
          })
          return false
        }
        if (this.image) {
          this.$store.commit('loader/change_dialog', true)
          this.$http.post('api/chat/upload', this.image).then(
            (res) => {
              this.blobImage = false
              this.image = ''
              this.editedItem.img_path = res.bodyText
              this.$store.commit('loader/change_dialog', false)
              this.save()
            },
            err => {
              this.$emit('err')
              this.$store.commit('snackbar/change_values', {
                text: 'Não foi possível salvar a imagem, reporte o erro.', color: 'error', dialog: true
              })
              this.$store.commit('loader/change_dialog', false)
            })
        } else {
          this.save()
        }
        // this.dialog = false
      },
      save () {
        this.$store.commit('loader/change_dialog', true)
        if (this.view === 3) {
          if (this.editedItem.users.length < 2) {
            this.$store.commit('snackbar/change_values', {
              text: 'É necessário ter pelo menos 2 usuário para o grupo.', color: 'warning', dialog: true
            })
            this.$store.commit('loader/change_dialog', false)
            return ''
          }
          this.$http.put('api/update_chat_room/' + this.editedItem.id, this.editedItem).then(
            (res) => {
              this.$emit('edit', this.editedItem)
              this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
              this.dialog = false
              this.$store.commit('loader/change_dialog', false)
            },
            err => {
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', {
                text: 'Não foi possível criar o chat, reporte o erro.', color: 'error', dialog: true
              })
            })
        } else {
          this.$http.post('api/create_chat', this.editedItem).then(
            (res) => {
              // Caso o chat já exista seta o a variavel alreadyExistChat para identificar no front e não criar outro chat
              this.$emit('create', res.body, res.body['alreadyExistChat'])

              this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
              this.dialog = false
              this.$store.commit('loader/change_dialog', false)
            },
            err => {
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', {
                text: 'Não foi possível criar o chat, reporte o erro.', color: 'error', dialog: true
              })
            })
        }
      },
      deleteGroup () {
        this.$http.delete('api/delete_chat_room/' + this.editedItem.id).then(
          (res) => {
            this.dialog = false
            this.$emit('delete', this.editedItem.id)
            this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
          },
          err => {
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível excluir o chat, reporte o erro.', color: 'error', dialog: true
            })
          })
      }
    },
    computed: {
      confirmation: function () {
        if (this.entity === 'none') {
          return this.text + '?'
        } else {
          return this.text + this.entity + '?'
        }
      }
    }
  }
</script>

<style scoped>
  .avatar-chip-connection {
    color: #fff;
    background-color: #00acc2;
    border-radius: 50%;
    width: 10px;
    height: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
  }

  .avatar-chip-connection img{
    width: 16px;
    height: 16px;
    border-radius: 50%;
  }

  .avatar_user {
    color: #fff;
    background-color: #00acc2;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .avatar_user h3 {
    font-size: 1.5em;
  }

  .selected-people{
    display: flex;
    align-items: center;
  }

  .selected-people .contact-infos{
    display: flex;
    flex-direction: column;
    align-items: left;
  }

  .selected-people .contact-infos .connection-info{
    display: flex;
    align-items: center;
  }

  .selected-people .contact-infos .connection-info span{
    font-size: 0.85em;
    color: #555;
  }

  .chat-loader{
    width: 100%;
    height: 100%;
    background: #00000090;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .chat-loader img{
    width: auto;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/PChatCreate.vue